import { React } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Grid, Cell } from '@digsup/components-grid';
import { Form, Yup } from '@digsup/components-form';
import { Text } from '@digsup/components-text';
import { Input, TextArea } from '@digsup/components-input';
import { Button } from '@digsup/components-button';

export const SignUpForm = ({ onSubmit }) => {
  const signUpFormSchema = Yup.object().shape({
    email: Yup.string().email('Invalid Email').required('Required'),
    firstName: Yup.string().required('Required'),
    lastName: Yup.string().required('Required'),
  });

  return (
    <Form
      onSubmit={values => {
        onSubmit({
          EMAIL: values.email,
          FNAME: values.firstName,
          LNAME: values.lastName,
          'MMERGE5[addr1]': values.streetAddress,
          'MMERGE5[addr2]': values.unit,
          'MMERGE5[city]': values.city,
          'MMERGE5[state]': values.state,
          'MMERGE5[zip]': values.zip,
          COMMENTS: values.comments,
        });
      }}
      validationSchema={signUpFormSchema}
      initialValues={{
        email: '',
        firstName: '',
        lastName: '',
        streetAddress: '',
        unit: '',
        city: '',
        state: '',
        zip: '',
        comments: '',
      }}>
      {() => (
        <Form.Context>
          <div className="u-margin-bottom-large">
            <Text
              size="7xs"
              fontWeight="semibold"
              align="start"
              marginBottom="xsmall">
              Email
            </Text>
            <Form.Field name="email">
              {({ field }) => <Input placeholder="Email address" {...field} />}
            </Form.Field>
          </div>

          <div className="u-margin-bottom-xlarge">
            <Text
              size="7xs"
              fontWeight="semibold"
              align="start"
              marginBottom="xsmall">
              Name
            </Text>
            <Grid gutter="small">
              <Cell columns="6">
                <Form.Field name="firstName">
                  {({ field }) => <Input {...field} placeholder="First Name" />}
                </Form.Field>
              </Cell>
              <Cell columns="6">
                <Form.Field name="lastName">
                  {({ field }) => <Input {...field} placeholder="Last Name" />}
                </Form.Field>
              </Cell>
            </Grid>
          </div>

          <Text color="theme-descriptive" marginBottom="medium">
            Optionally, enter your address for information about your property
            before launch:
          </Text>
          <div className="u-margin-bottom-large">
            <Text
              size="7xs"
              fontWeight="semibold"
              align="start"
              marginBottom="xsmall">
              Street Address (USA Only)
            </Text>
            <Form.Field name="streetAddress">
              {({ field }) => (
                <Input placeholder="Street Address (USA Only)" {...field} />
              )}
            </Form.Field>
          </div>
          <div className="u-margin-bottom-large">
            <Grid gutter="small">
              <Cell columns="6">
                <Text
                  size="7xs"
                  fontWeight="semibold"
                  align="start"
                  marginBottom="xsmall">
                  Unit
                </Text>
                <Form.Field name="unit">
                  {({ field }) => (
                    <Input {...field} placeholder="Unit (if applicable)" />
                  )}
                </Form.Field>
              </Cell>
              <Cell columns="6">
                <Text
                  size="7xs"
                  fontWeight="semibold"
                  align="start"
                  marginBottom="xsmall">
                  City
                </Text>
                <Form.Field name="city">
                  {({ field }) => <Input {...field} placeholder="City" />}
                </Form.Field>
              </Cell>
            </Grid>
          </div>
          <div className="u-margin-bottom-large">
            <Grid gutter="small">
              <Cell columns="6">
                <Text
                  size="7xs"
                  fontWeight="semibold"
                  align="start"
                  marginBottom="xsmall">
                  State
                </Text>
                <Form.Field name="state">
                  {({ field }) => <Input {...field} placeholder="State" />}
                </Form.Field>
              </Cell>
              <Cell columns="6">
                <Text
                  size="7xs"
                  fontWeight="semibold"
                  align="start"
                  marginBottom="xsmall">
                  Zip Code
                </Text>
                <Form.Field name="zip">
                  {({ field }) => <Input {...field} placeholder="Zip Code" />}
                </Form.Field>
              </Cell>
            </Grid>
          </div>
          <div className="u-margin-bottom-xlarge">
            <Text
              size="7xs"
              fontWeight="semibold"
              align="start"
              marginBottom="xsmall">
              Comments
            </Text>
            <Form.Field name="comments">
              {({ field }) => (
                <TextArea placeholder="Comments?" rows={4} {...field} />
              )}
            </Form.Field>
          </div>
          <div className="u-margin-bottom-small u-padding-right-large u-padding-left-large u-padding-right-xxlarge@small u-padding-left-xxlarge@small">
            <Button type="submit" size="large" width="full" variant="primary">
              Request Invite
            </Button>
          </div>
        </Form.Context>
      )}
    </Form>
  );
};

SignUpForm.propTypes = {
  /**
   * onSubmit callback
   */
  onSubmit: PropTypes.func.isRequired,
};
